<template>
  <div>
    <!-- CPU 사용 미터링 -->
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r4">CPU 사용 미터링</div>
        <el-switch v-model="meteringInfo.CORE_USE.value" active-value="1" inactive-value="0" @change="changeTargetValue(arguments[0], ...'CORE_USE')"></el-switch>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" :disabled="coreSaveDisabled" @click="onSaveButtonClick(['CORE_USE', 'CORE_COST'])">저장</el-button>
        <el-button :disabled="coreSaveDisabled" @click="loadData(['CORE_USE', 'CORE_COST'])">취소</el-button>
      </div>
    </el-row>
    <el-row class="mr-b30">
      <div class="list form-list">
        <el-form label-width="200px" label-position="left">
          <el-form-item label="코어당 단가">
            <el-input v-model.number="meteringInfo.CORE_COST.value" type="number" style="width: calc(100% - 24px)" :min="0" :max="9999999999"
            @keyup.native="changeTargetValue(arguments[0].target.value, ...'CORE_COST')" @change="changeTargetValue(...arguments, ...'CORE_COST')"></el-input>
            <span class="mr-l4">원</span>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <!-- MEM 사용 미터링 -->
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r4">MEM 사용 미터링</div>
        <el-switch v-model="meteringInfo.MEM_USE.value" active-value="1" inactive-value="0" @change="changeTargetValue(arguments[0], ...'MEM_USE')"></el-switch>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" :disabled="memSaveDisabled" @click="onSaveButtonClick(['MEM_USE', 'MEM_COST'])">저장</el-button>
        <el-button :disabled="memSaveDisabled" @click="loadData(['MEM_USE', 'MEM_COST'])">취소</el-button>
      </div>
    </el-row>
    <el-row class="mr-b30">
      <div class="list form-list">
        <el-form label-width="200px" label-position="left">
          <el-form-item label="1G 당 단가">
            <el-input v-model.number="meteringInfo.MEM_COST.value" type="number" style="width: calc(100% - 24px)" :min="0" :max="9999999999"
            @keyup.native="changeTargetValue(arguments[0].target.value, ...'MEM_COST')" @change="changeTargetValue(...arguments, ...'MEM_COST')"></el-input>
            <span class="mr-l4">원</span>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <!-- DISK 사용 미터링 -->
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r4">DISK 사용 미터링</div>
        <el-switch v-model="meteringInfo.DISK_USE.value" active-value="1" inactive-value="0" @change="changeTargetValue(arguments[0], ...'DISK_USE')"></el-switch>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" :disabled="diskSaveDisabled" @click="onSaveButtonClick(['DISK_USE', 'DISK_COST'])">저장</el-button>
        <el-button :disabled="diskSaveDisabled" @click="loadData(['DISK_USE', 'DISK_COST'])">취소</el-button>
      </div>
    </el-row>
    <el-row class="mr-b30">
      <div class="list form-list">
        <el-form label-width="200px" label-position="left">
          <el-form-item label="1G 당 단가">
            <el-input v-model.number="meteringInfo.DISK_COST.value" type="number" style="width: calc(100% - 24px)" :min="0" :max="9999999999"
            @keyup.native="changeTargetValue(arguments[0].target.value, ...'DISK_COST')" @change="changeTargetValue(...arguments, ...'DISK_COST')"></el-input>
            <span class="mr-l4">원</span>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <!-- NETWORK 사용 미터링 -->
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r4">NETWORK 사용 미터링</div>
        <el-switch v-model="meteringInfo.NETWORK_USE.value" active-value="1" inactive-value="0" @change="changeTargetValue(arguments[0], ...'NETWORK_USE')"></el-switch>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" :disabled="networkSaveDisabled" @click="onSaveButtonClick(['NETWORK_USE', 'NETWORK_IN_COST', 'NETWORK_OUT_COST'])">저장</el-button>
        <el-button :disabled="networkSaveDisabled" @click="loadData(['NETWORK_USE', 'NETWORK_IN_COST', 'NETWORK_OUT_COST'])">취소</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="title-bar title-h4 dot-title">IN bound</div>
      <div class="list form-list mr-b15">
        <el-form label-width="200px" label-position="left">
          <el-form-item label="1Mbps 당">
            <el-input v-model.number="meteringInfo.NETWORK_IN_COST.value" type="number" style="width: calc(100% - 24px)" :min="0" :max="9999999999"
            @keyup.native="changeTargetValue(arguments[0].target.value, ...'NETWORK_IN_COST')" @change="changeTargetValue(...arguments, ...'NETWORK_IN_COST')"></el-input>
            <span class="mr-l4">원</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="title-bar title-h4 dot-title">OUT bound</div>
      <div class="list form-list">
        <el-form label-width="200px" label-position="left">
          <el-form-item label="1Mbps 당">
            <el-input v-model.number="meteringInfo.NETWORK_OUT_COST.value" type="number" style="width: calc(100% - 24px)" :min="0" :max="9999999999"
            @keyup.native="changeTargetValue(arguments[0].target.value, ...'NETWORK_OUT_COST')" @change="changeTargetValue(...arguments, ...'NETWORK_OUT_COST')"></el-input>
            <span class="mr-l4">원</span>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { camelCase, cloneDeep, isEqual, isNil, mapKeys } from 'lodash';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import msgUtil from '@/utils/message';

export default {
  name: 'WMeteringForm',
  data() {
    return {
      flag: true,
      meteringInfo: {
        CORE_COST: {},
        CORE_USE: {},
        DISK_COST: {},
        DISK_USE: {},
        MEM_COST: {},
        MEM_USE: {},
        NETWORK_IN_COST: {},
        NETWORK_OUT_COST: {},
        NETWORK_USE: {},
      },
      originMeteringInfo: {},
    };
  },
  computed: {
    coreSaveDisabled() {
      const coreCost = this.meteringInfo.CORE_COST;
      const coreUse = this.meteringInfo.CORE_USE;
      return !(coreCost.isModified || coreUse.isModified);
    },
    memSaveDisabled() {
      const memCost = this.meteringInfo.MEM_COST;
      const memUse = this.meteringInfo.MEM_USE;
      return !(memCost.isModified || memUse.isModified);
    },
    diskSaveDisabled() {
      const diskCost = this.meteringInfo.DISK_COST;
      const diskUse = this.meteringInfo.DISK_USE;
      return !(diskCost.isModified || diskUse.isModified);
    },
    networkSaveDisabled() {
      const netInCost = this.meteringInfo.NETWORK_IN_COST;
      const netOutCost = this.meteringInfo.NETWORK_OUT_COST;
      const netUse = this.meteringInfo.NETWORK_USE;
      return !(netInCost.isModified || netOutCost.isModified || netUse.isModified);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData(basicinfoSubids) {
      basicinfoSetAPI.getList('VMMETERING').then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.setMeteringInfo(result, basicinfoSubids);
        }
      });
    },
    /**
     * 미터링 data 가공
     * @author jeee12
     * @param  {[type]} meteringInfos   데이터 조회 결과 list
     * @param  {[type]} basicinfoSubids 가공할 basicinfoSubids
     */
    setMeteringInfo(meteringInfos, basicinfoSubids) {
      if (!isNil(basicinfoSubids)) { // 조합할 특정 basicinfoSubid가 있는 경우
        basicinfoSubids.forEach((basicinfoSubid) => {
          const matchedInfo = meteringInfos.find((data) => data.basicinfoSubid === basicinfoSubid);
          const datatypeId = matchedInfo.datatypeId === 'BOOL' ? 'BOOLEAN' : matchedInfo.datatypeId;
          this.meteringInfo[matchedInfo.basicinfoSubid] = {
            value: matchedInfo[camelCase(`basicinfoSubvalue${datatypeId}`)],
            datatypeId,
            isModified: false,
          };
        });
      } else {
        meteringInfos.forEach((data) => {
          const datatypeId = data.datatypeId === 'BOOL' ? 'BOOLEAN' : data.datatypeId;
          this.meteringInfo[data.basicinfoSubid] = {
            value: data[camelCase(`basicinfoSubvalue${datatypeId}`)],
            datatypeId,
            isModified: false,
          };
        });
      }
      this.originMeteringInfo = cloneDeep(this.meteringInfo);
    },
    /**
    * 미터링 정보 저장
    * @author jeee12
    * @param  {[type]} basicinfoSubids 저장할 basicinfoSubids
    */
    onSaveButtonClick(basicinfoSubids) {
      const target = '정보';
      const action = msgUtil.action.SAVE;
      const params = [];
      mapKeys(this.meteringInfo, (value, key) => {
        const basicinfoSubid = key;
        const isMatched = basicinfoSubids.indexOf(basicinfoSubid) > -1;
        if (isMatched && value.isModified) {
          const subValueKey = camelCase(`basicinfoSubvalue${value.datatypeId}`);
          const subValue = value.datatypeId === 'INTEGER' ? Number(value.value) : value.value;
          params.push({
            basicinfoId: 'VMMETERING',
            basicinfoSubid,
            [subValueKey]: subValue,
          });
        }
      });

      basicinfoSetAPI.updateList(params).then((response) => {
        if (response.data.success) {
          this.loadData(basicinfoSubids);
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 대상 값에 대한 수정여부 체크
     * @author jeee12
     * @param  {[type]} value     change 또는 keyup 이벤트 대상 값
     * @param  {[type]} targetKey 대상 값의 key
     */
    changeTargetValue(value, targetKey) {
      if (!isNaN(value)) { // 숫자만 허용
        const changedInfo = this.meteringInfo;
        const originInfo = this.originMeteringInfo;
        this.meteringInfo[targetKey].isModified = !isEqual(changedInfo[targetKey].value, originInfo[targetKey].value);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Metering/ServerVirtualization/components/MeteringForm.vue